<div>
  <div class="mmap">
    <link href='https://api.mapbox.com/mapbox-gl-js/v0.47.0/mapbox-gl.css' rel='stylesheet'>
    <!--https://docs.mapbox.com/api/maps/#styles
    good examples https://stackblitz.com/edit/ngx-mapbox-gl?file=app%2Fdemo%2Findex.component.ts -->
    <mgl-map [mapStyle]="openMapTileUrl" class="w-100" [center]="defaultCenter"  [zoom]="[defaultZoom]"
      (mapLoad)="onMapLoad($event)">
      <mgl-control mglFullscreen></mgl-control>
      <mgl-control [position]="'top-left'">
        <kendo-panelbar>
          <kendo-panelbar-item [title]="'HOME_COMPONENTS.WORKORDERS_MAP.LAYERS' | translate" [expanded]="false">
            <ng-template kendoPanelBarContent>
              @if (additionalLayers?.length>0) {
                <div class="bg-white bg-gradient shadow-lg px-3 py-1 mb-3 " id="layers">
                  @for (layer of additionalLayers; track trackByFn($index, layer)) {
                    <div class=" align-items-center">
                      <div class="d-flex fw-bold">
                        <div class=" col "> <kendo-label class="small-text" [text]="getAdditionalLayerTranslationKey(layer.name) | translate">
                          <i class="{{layer.icon}} fs-6 m-1"></i>
                        </kendo-label></div>
                        <div class=" col-auto">
                          <kendo-switch size="small" class="m-1"  [(ngModel)]="layer.visible" (valueChange)="toggleLayerVisibility(layer.name)"></kendo-switch>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>

        <div class="bg-white shadow-lg px-3 py-1 mb-3 mt-3">
          <div class="small-text">
            <div class="d-flex fw-bold">
              <div class=" col "> {{ 'HOME_COMPONENTS.WORKORDERS_MAP.WORKORDERS_SELECTED' | translate }} </div>
              <div class=" col-auto"> {{ selectedWorkOrders().length| number }}</div>
            </div>
          </div>
        </div>
        <app-legend-control [contractName]="contractName()" [fsrNamesOnMap]="fsrNames4LegendC" [teamsOnMap]="teams4LegendC"></app-legend-control>
        <!--  Legend for Task Status -->
        <!-- any change made to the colour has to be chnaged in BE(public.ola_get_layer_tile_on_the_fly) function as well -->
        <div class="mt-3 bg-white shadow-lg px-3 py-1 mb-3 ">
          <div class="small-text">
            <div class="d-flex fw-bold">
              <div class="col"> {{ 'HOME_COMPONENTS.WORKORDERS_MAP.WORK_ORDER_STATUS' | translate }}</div>
              <div class="col-auto ps-2"> {{ 'HOME_COMPONENTS.WORKORDERS_MAP.COLOR' | translate }}</div>
            </div>
            <div class="d-flex ">
              <div class="col "> {{ 'HOME_COMPONENTS.WORKORDERS_MAP.READY_FOR_DISPATCH' | translate }}</div>
              <div class="col-auto ps-2"> <span class="dot" style="background-color:#646464"></span></div>
            </div>
            <div class="d-flex ">
              <div class="col"> {{ 'HOME_COMPONENTS.WORKORDERS_MAP.COMPLETED' | translate }}</div>
              <div class="col-auto ps-2">
                <span class="dot" style="border: 1px solid #39FF14; border-radius: 50%"></span>
              </div>
            </div>
          </div>
        </div>
      </mgl-control>
      <mgl-control mglNavigation [position]="'bottom-right'" [showCompass]="false"></mgl-control>
    </mgl-map>
  </div>
  @if (loadingMap() === true || pendingMapSelection() === true) {
    <kendo-skeleton
      shape="rectangle"
      animation="pulse"
      [width]="'100%'"
      [height]="4"
      class="text-bg-primary"
    ></kendo-skeleton>
  }
  @if (_mapSharedUtilService.showModePopup() === true) {
    <kendo-popup  class="content"
      >
      <span> <i class="m-3 pl-2 fa-solid fa-circle-info"></i>{{ 'HOME_COMPONENTS.WORKORDERS_MAP.UNSELECT_MODE_ON' | translate }} <i class="m-2 fa-solid fa-close" (click)="_mapSharedUtilService.showModePopup.set(false)"></i></span>
    </kendo-popup>
  }
</div>
